<template>
  <div>
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <div class="toolbtn flex">
          <switchcore></switchcore>
          <el-tooltip class="item" effect="dark" content="刷新" placement="top">
            <div @click="refresh()" class="cursorpointer margin-top10">
              <img
                src="@/assets/barsvg/icon／12sx(1).png"
                style="position: relative; top: 2px"
                alt=""
              />
              <span class="f12 pad-left5" style="color: #969eac">刷新</span>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="返回" placement="top">
            <callback></callback>
          </el-tooltip>
        </div>
        <!-- 关键词检索  -->
        <div
          class="width100 f14 backwhite border-rd3 flexleft"
          style="min-height: 72px"
          v-if="serchkey"
        >
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            size="small"
            label-width="100px"
            class="demo-ruleForm width90 flexleft"
          >
            <el-form-item label="同行名称">
              <el-input
                placeholder="请输入同行名称"
                v-model="ruleForm.input"
              ></el-input>
            </el-form-item>
            <div class="margin-left20">
              <el-button type="primary" class="searchbut" @click="submitForm()"
                >检 索</el-button
              >
              <el-button @click="resetForm()" class="resetbtn">重 置</el-button>
            </div>
          </el-form>

          <span
            class="attention margin-top10 margin-bot10 margin-left20"
            @click="dialogVisibles = true"
            >新 增</span
          >
        </div>
        <div
          class="
            width100
            margin-auto
            backwhite
            margin-top15
            pad-top20
            alldigital
          "
          v-if="total != 0"
        >
          <div
            class="
              width99
              margin-auto
              flex-around
              hight40
              lineheight40
              f14
              backef
              titcolor
              borderb
            "
          >
            <span class="width60 pad-left20">同行名称</span
            ><span class="width10">监控时间</span>
            <span class="width20">数据更新</span>
            <span class="width10">操作</span>
          </div>
          <div
            class="
              lineheight30
              f14
              width100
              borderbbb
              pad-top10 pad-bot10
              hovercont
            "
            v-for="(item, index) in page"
            :key="index"
            style="color: #606266"
          >
            <div class="flex-around">
              <div class="width60 pad-left20">
                <span class="width100 bluecolor cursorpointer f14">{{
                  item.company_name == null ? "" : item.company_name
                }}</span>
              </div>
              <div class="width10">
                <span class="width100"
                  >{{ item.create_time.substring(0, 10) }}
                </span>
              </div>
              <div class="width20">
                <span class="width100">{{
                  item.update_time.substring(0, 10)
                }}</span>
              </div>
              <div class="width10 cursorpointer">
                <span style="color: #52c5cb" @click="designDetail(index)"
                  >取消监控</span
                >
              </div>
            </div>
            <p class="width98 margin-auto pad-left10">
              <span>商标:{{ item.trademark_count }} </span
              ><span class="pad-left10"> 发明专利:{{ item.fmzl_count }}</span
              ><span class="pad-left10"> 实用新型：{{ item.syxx_count }}</span
              ><span class="pad-left10"> 外观专利：{{ item.wgzl_count }}</span>
            </p>
            <div class="cont-massge" @click="tomessageCenter()">
              <el-carousel
                height="25px"
                :interval="5000"
                indicator-position="none"
                arrow="never"
              >
                <el-carousel-item v-for="i in 4" :key="i">
                  {{ item.message[0].update_time + item.message[0].message }}
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div
            class="
              flex-betweennowrap
              pad-top20 pad-bot20 pad-left10 pad-right10
            "
            v-if="total != 0"
          >
            <span class="bluecolor f14"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisibles"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left dimensional">
        <span>新增监控</span>
      </p>

      <div class="margin-top30 margin-bot30">
        <p class="textalign-left pad-bot10">企业名称</p>
        <p class="textalign-left">
          <el-input
            v-model="addinput"
            placeholder="请输入完整的企业名称"
            class="width100"
          ></el-input>
        </p>
      </div>

      <div class="textalign-right pad-top20">
        <el-button @click="dialogVisibles = false">取 消</el-button>
        <el-button type="primary" @click="addproject()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  <script>
import {
  opponentList,
  entmonitorremove,
  ADDmonitordetail,
} from "@/api/patent/patent.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      ruleForm: {
        input: "",
      },
      thisNum: 1,
      currentPage: 1,
      page: [],
      total: 0,
      per_page: 0,
      progress: "",
      serchkey: true,
      input: "",
      nullcont: "",
      dialogVisibles: false,
      addinput: "",
    };
  },

  components: {
    callback,
    switchcore,
  },
  methods: {
    // 关键词检索
    submitForm() {
      if (this.ruleForm.input != "") {
        opponentList({
          _keywords: this.ruleForm.input,
          page: 1,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
            this.page.forEach((i) => {
              if (i.message.length != 0) {
                i.message[0].update_time =
                  "[" + i.message[0].update_time.slice(0, 10) + "]";
              }
              if (i.message.length == 0) {
                i.message.push({
                  message: "暂时没有技术专利更新",
                  update_time: "",
                });
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },

    // 新增
    addproject() {
      ADDmonitordetail({ company_name: this.addinput }).then((res) => {
        if (res.data.code == 200) {
          this.dialogVisibles = false;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    //跳转消息中心
    tomessageCenter() {
      this.$router.push({
        path: "/Message-Center/Messages",
      });
    },
    // 删除
    designDetail(index) {
      this.$confirm("此操作将取消监控, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entmonitorremove({ id: this.page[index].id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      opponentList({
        page: val,
        _keywords: this.ruleForm.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            if (i.message.length != 0) {
              i.message[0].update_time =
                "[" + i.message[0].update_time.slice(0, 10) + "]";
            }
            if (i.message.length == 0) {
              i.message.push({
                message: "暂时没有技术专利更新",
                update_time: "",
              });
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      opponentList({
        page: 1,
        limit: val,
        _keywords: this.ruleForm.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            if (i.message.length != 0) {
              i.message[0].update_time =
                "[" + i.message[0].update_time.slice(0, 10) + "]";
            }
            if (i.message.length == 0) {
              i.message.push({
                message: "暂时没有技术专利更新",
                update_time: "",
              });
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.ruleForm.input = null;
      this.thisNum = 1;
      opponentList({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            if (i.message.length != 0) {
              i.message[0].update_time =
                "[" + i.message[0].update_time.slice(0, 10) + "]";
            }
            if (i.message.length == 0) {
              i.message.push({
                message: "暂时没有技术专利更新",
                update_time: "",
              });
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      opponentList({
        page: this.thisNum,
        _keywords: this.ruleForm.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            if (i.message.length != 0) {
              i.message[0].update_time =
                "[" + i.message[0].update_time.slice(0, 10) + "]";
            }
            if (i.message.length == 0) {
              i.message.push({
                message: "暂时没有技术专利更新",
                update_time: "",
              });
            }
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    if (window.sessionStorage.getItem("navigetionval") == null) {
      this.thisNum = 1;
      this.currentPage1 = 1;
    } else {
      this.thisNum = window.sessionStorage.getItem("navigetionval");
      this.currentPage1 = parseInt(
        window.sessionStorage.getItem("navigetionval")
      );
    }

    opponentList({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.page.forEach((i) => {
          if (i.message.length != 0) {
            i.message[0].update_time =
              "[" + i.message[0].update_time.slice(0, 10) + "]";
          }
          if (i.message.length == 0) {
            i.message.push({
              message: "暂时没有技术专利更新",
              update_time: "",
            });
          }
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
  <style scoped>
.el-input {
  width: 100%;
}
.cont-massge {
  width: 98%;
  margin: auto;
  height: 25px;
  background: #fbfbfb;
  color: #52c5cb;
  font-size: 12px;
  border-radius: 4px;
  margin-top: 5px;
  line-height: 25px;
  padding-left: 10px;
}

.btnn {
  width: 100%;
  height: 25%;
  margin: auto;
  border: none;
  background: white;
}
.hovercont:hover {
  background: #f7f9fc;
}
.inputinner >>> .el-input__inner {
  border: none;
}
.inputinner >>> .el-button {
  border: none;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
  border-radius: 12px;
}
</style>